import React from 'react';
import './index.css';
import { Step1Props } from '../../../../../redux/AllocationRequest';

export const Step1: React.FC<Step1Props> = ({ selected, onSelect }) => {
  const types = [
    { name: "Product Quantity", icon: "📦", desc: "Request specific quantities of products" },
    { name: "Cart Allocation", icon: "🛒", desc: "Allocate products to carts & channels" },
    { name: "Bulk Cart Allocation", icon: "📊", desc: "Bulk allocate quantities across all carts in a grid view" },
  ];

  return (
    <div className="step1-container">
      <p className="step1-title">What type of request is this?</p>
      <div className="step1-grid">
        {types.map(t => (
          <div
            key={t.name}
            onClick={() => onSelect(t.name)}
            className={`step1-card ${selected === t.name ? 'step1-card-selected' : 'step1-card-unselected'}`}
          >
            <div className="step1-icon">{t.icon}</div>
            <div className="step1-name">{t.name}</div>
            <div className="step1-desc">{t.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};